import type { BaseTranslation } from '@i18n/i18n-types';

export const payment = {
    savedCard: 'Saved card',
    otherPaymentMethod: 'Other payment methods',
    payWithSavedCard: 'Pay with saved card',
    payWithNewCard: 'Buy with a new card',
    completePurchase: 'Complete purchase',
    removeCard: {
        title: 'Remove this card?',
        text: 'Are you sure you want to delete this card?',
    },
    spinnerDialog: {
        title: 'Processing payment',
        text: 'Please, don’t close the page',
    },
    sale: {
        offer: '{contest:string} offer!',
        buyMinutes: 'Buy minutes with {percent:number}% OFF only on {contest:string}',
        buySubscription: 'Buy premium with {percent:number}% OFF only on {contest:string}',
        buyNow: 'Buy now',
    },
} satisfies BaseTranslation;
